import { DialogPlugin } from '@modules/forms/models/dialog-plugin';
import { ModuleId } from '@pixacare/forms';
import { DressfitModuleComponentByModuleId } from '../models/dressfit-module-component-by-module-id';
import { DressfitSupportedModuleIds } from '../models/dressfit-supported-module-ids';
import { DressfitInteractiveModuleComponent } from '../modules/dressfit/components/dressfit-interactive-module/dressfit-interactive-module.component';

type DressfitModules = {
  [M in DressfitSupportedModuleIds]: DialogPlugin<DressfitModuleComponentByModuleId[M]>;
};

export const dressfitModules = {
  [ModuleId.DRESSFIT]: {
    id: ModuleId.DRESSFIT,
    component: DressfitInteractiveModuleComponent,
    dependencies: [],
    inputs: {},
    outputs: {
      dressings: 'dressings',
      primaryDressings: 'primaryDressings',
      secondaryDressings: 'secondaryDressings',
      compositeDressings: 'compositeDressings',
      unknownDressings: 'unknownDressings',
      instructions: 'instructions',
      rationale: 'rationale',
      record: 'record',
    },
  },
} satisfies DressfitModules;
